export enum JobCandidateStatus {
  New = 'new',
  ResumeAnalyzed = 'resume_analyzed',
  Shortlist = 'shortlist',
  Interview = 'interview',
  InterviewCompleted = 'interview_completed',
  Rejected = 'rejected',
  Pass = 'pass',
  Fatal = 'fatal',
  Withdrawn = 'withdrawn'
}

export function getJobCandidateStatusLabel(status: JobCandidateStatus): string {
  switch (status) {
    case JobCandidateStatus.New:
      return 'Imported';
    case JobCandidateStatus.ResumeAnalyzed:
      return 'Resume Screening';
    case JobCandidateStatus.Shortlist:
      return 'Shortlist';
    case JobCandidateStatus.Interview:
      return 'Interview';
    case JobCandidateStatus.InterviewCompleted:
      return 'Interview Completed';
    case JobCandidateStatus.Rejected:
      return 'Rejected';
    case JobCandidateStatus.Pass:
      return 'Passed';
    case JobCandidateStatus.Fatal:
      return 'Imported Failed';
    case JobCandidateStatus.Withdrawn:
      return 'Withdrawn';
    default:
      return 'Unknown';
  }
}

export function getStatusList(
  currentStatus: JobCandidateStatus,
  progress: JobCandidateStatus[]
): {
  status: string[];
  index: number;
} {
  if (
    currentStatus === JobCandidateStatus.Pass ||
    currentStatus === JobCandidateStatus.Rejected ||
    currentStatus === JobCandidateStatus.Withdrawn
  ) {
    const statusLabels = progress.map((status) => {
      return getJobCandidateStatusLabel(status);
    });

    return {
      status: statusLabels,
      index: progress.length - 1
    };
  }

  const statusList = [
    JobCandidateStatus.New,
    JobCandidateStatus.ResumeAnalyzed,
    JobCandidateStatus.Shortlist,
    JobCandidateStatus.Interview,
    JobCandidateStatus.InterviewCompleted,
    JobCandidateStatus.Pass
  ];

  const statusLabels = statusList.map((status) => {
    return getJobCandidateStatusLabel(status);
  });

  const currentIndex = statusList.indexOf(currentStatus);

  return {
    status: statusLabels,
    index: currentIndex
  };
}

export function isStatusBeforeInterviewCompleted(status: JobCandidateStatus): boolean {
  const statusBeforeInterviewCompleted = [
    JobCandidateStatus.New,
    JobCandidateStatus.ResumeAnalyzed,
    JobCandidateStatus.Shortlist,
    JobCandidateStatus.Interview
  ];

  return statusBeforeInterviewCompleted.includes(status);
}
